import React from 'react'
import { LocalizationContextType } from '../../shared/contexts'
import { formatTenantDateTime } from '../../../utils/formatTenantDateTime'

export interface HeatEnergyReading {
  id: number
  recorded_at: string | null
  heat_energy_in_pan: number
  cooker_slot_number: number | null
  recipe_name: string | null
  order_number: string | null
}

interface HeatEnergyReadingsTableProps {
  readings: HeatEnergyReading[]
  localization_context?: LocalizationContextType
}

const NA = '—'

const HeatEnergyReadingsTable: React.FC<HeatEnergyReadingsTableProps> = ({ readings, localization_context }) => (
  <table className="table table-robis">
    <thead className="thead-robis">
      <tr>
        <th scope="col">Recorded At</th>
        <th scope="col">Meal</th>
        <th scope="col">Order</th>
        <th scope="col">Recipe</th>
        <th scope="col">Cooker</th>
        <th scope="col">Heat Energy In Pan (kW)</th>
      </tr>
    </thead>
    <tbody>
      {readings.map((reading) => (
        <tr key={reading.id}>
          <td>
            <div className="small">
              {reading.recorded_at ? formatTenantDateTime(reading.recorded_at, localization_context) : NA}
            </div>
          </td>
          <td>
            <a href={`/queued_orders/${reading.id}`}>#{reading.id}</a>
          </td>
          <td>
            <span className="small">{reading.order_number || NA}</span>
          </td>
          <td>
            <span>{reading.recipe_name || NA}</span>
          </td>
          <td>
            <span className="small">{reading.cooker_slot_number ?? NA}</span>
          </td>
          <td>
            <span className="small">{reading.heat_energy_in_pan}</span>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
)

export default HeatEnergyReadingsTable
